import { render, staticRenderFns } from "./RankingBlock.vue?vue&type=template&id=a0d7813a"
import script from "./RankingBlock.vue?vue&type=script&lang=ts"
export * from "./RankingBlock.vue?vue&type=script&lang=ts"
import style0 from "./RankingBlock.vue?vue&type=style&index=0&id=a0d7813a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports